import { Col, Row, Typography } from "antd";
import React from "react";

const Disclaimer = () => {
  return (
 
    <Row
      className="whiteBackground"
      style={{
        backgroundColor: "white",
        justifyContent: "center",
        margin: "50px 0px",
      }}
    >
      <Col xs={24} md={10}>
         <Typography.Title
          className="fontFamily1 contactbnr-content"
          style={{textAlign:'center' , fontSize: "30px", color: "#333d47", marginBottom:20 }}
        >
          {<>Disclaimer</>}
        </Typography.Title>
        <div>
          <p
            className="fontFamily1"
            style={{ fontSize: "20px", marginBottom: "20px" }}
          >
            WrightCo Academy provides this Learning Management System (LMS) as a
            platform to support the professional development of individuals and
            organizations in the early care and education field. While we strive
            to provide accurate, up-to-date, and relevant training content,
            WrightCo Academy makes no guarantees regarding the completeness,
            accuracy, or applicability of the materials for specific programs or
            regulatory requirements. Use of the LMS is at your own discretion.
            WrightCo Academy is not liable for any decisions made or actions
            taken based on the training content. It is the responsibility of
            each user and organization to ensure compliance with all applicable
            local, state, and federal regulations. Certificates of completion
            are issued for courses successfully completed through the LMS. These
            certificates may be used to document participation in continuing
            education and professional development; however, they do not
            represent licensure, certification, or formal credentialing unless
            explicitly stated.
          </p>
        </div>
      </Col>
    </Row>
  );
};

export default Disclaimer;
